<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Ordens de Serviço</h1>
        <p class="text-sm text-gray-500">Gerencie suas Ordens de Serviço</p>
      </div>
      <button (click)="createServiceOrder()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Nova OS
      </button>
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
    <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="Buscar por cliente ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      
    <p-dropdown
          [options]="status"
          [(ngModel)]="selectedStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>


        <div class="flex items-center">
          <p-datepicker [(ngModel)]="initialDate" (onSelect)="onStatusChange()" dateFormat="dd/mm/yy" />
        </div>
        <div class="flex items-center">
          <p-datepicker [(ngModel)]="finalDate" (onSelect)="onStatusChange()" dateFormat="dd/mm/yy" />
        </div>

      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} OS encontrada(s)
      </div>

    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="serviceOrders" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Cliente</th>
            <th class="text-left px-6 py-3">Data</th>
            <th class="text-left px-6 py-3">Total (R$)</th>
            <th class="text-left px-6 py-3">Status</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-os let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ os.id }}</td>
            <td class="px-6 py-2 font-mono">{{ os.customerName }}</td>
            <td class="px-6 py-2 text-gray-900">{{ os.date | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="px-6 py-2 text-green-600 font-medium">R$ {{ os.total | number: '1.2-2' }}</td>
            <td class="px-6 py-2">
               <span class="px-2 py-1 rounded-full text-xs font-bold" [ngClass]="{
                'bg-yellow-100 text-yellow-800': os.status === 'PENDING',
                'bg-green-100 text-green-800': os.status === 'COMPLETED',
                'bg-red-100 text-red-800': os.status === 'CANCELLED'
              }">
                {{ os.status === 'PENDING' ? 'Pendente' : (os.status === 'COMPLETED' ? 'Concluída' : 'Cancelada') }}
              </span>
            </td>
            
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Visualizar"
                  icon="pi pi-eye"
                  text
                  severity="info"
                  (click)="openViewModal(os)">
                </p-button>
                <p-button
                  *ngIf="os.status !== 'CANCELLED'"
                  pTooltip="Editar"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="view(os)">
                </p-button>
                <p-button
                  *ngIf="os.status !== 'CANCELLED'"
                  pTooltip="Cancelar"
                  icon="pi pi-times-circle"
                  text
                  severity="danger"
                  (click)="cancel(os)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhuma OS encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>


    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>

  </div>
</div>

<!-- Modal de Visualização -->
<p-dialog 
  [(visible)]="displayModal" 
  [modal]="true" 
  [style]="{width: '90vw', maxWidth: '1200px'}"
  [closable]="true"
  [draggable]="false"
  [resizable]="true"
  header="Resumo da Ordem de Serviço"
  (onHide)="closeModal()">
  
  <div *ngIf="selectedServiceOrder && !loadingModal" class="p-4">
    <p-tabview>
      <!-- Aba 1: Dados Principais -->
      <p-tabpanel header="Dados Principais">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Código</label>
            <p class="text-gray-900 font-mono">{{ selectedServiceOrder.id }}</p>
          </div>
          
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Cliente</label>
            <p class="text-gray-900">{{ selectedServiceOrder.customerName }}</p>
          </div>
          
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Data</label>
            <p class="text-gray-900">{{ selectedServiceOrder.date | date: 'dd/MM/yyyy HH:mm' }}</p>
          </div>
          
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Status</label>
            <span class="px-3 py-1 rounded-full text-sm font-bold" [ngClass]="getStatusClass(selectedServiceOrder.status)">
              {{ getStatusLabel(selectedServiceOrder.status) }}
            </span>
          </div>
          
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Desconto</label>
            <p class="text-gray-900">R$ {{ selectedServiceOrder.discount | number: '1.2-2' }}</p>
          </div>
          
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-1">Total</label>
            <p class="text-green-600 font-bold text-lg">R$ {{ selectedServiceOrder.total | number: '1.2-2' }}</p>
          </div>
          
          <div *ngIf="selectedServiceOrder.observation" class="md:col-span-2">
            <label class="block text-sm font-semibold text-gray-700 mb-1">Observações</label>
            <p class="text-gray-900 whitespace-pre-wrap">{{ selectedServiceOrder.observation }}</p>
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 2: Checklist -->
      <p-tabpanel header="Checklist">
        <div class="mt-4">
          <div *ngIf="checklistItems.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div 
              *ngFor="let item of checklistItems" 
              class="flex items-center gap-3 p-3 bg-gray-50 rounded">
              <i [class]="item.checked ? 'pi pi-check-circle text-green-600' : 'pi pi-circle text-gray-400'"></i>
              <span [class]="item.checked ? 'line-through text-gray-500' : 'text-gray-900'">
                {{ item.text }}
              </span>
            </div>
          </div>
          <div *ngIf="checklistItems.length === 0" class="text-center text-gray-500 py-8">
            Nenhum item no checklist
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 3: Campos Personalizados -->
      <p-tabpanel header="Informações">
        <div class="mt-4">
          <div *ngIf="customFieldValues.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div *ngFor="let field of customFieldValues">
              <label class="block text-sm font-semibold text-gray-700 mb-1">{{ getFieldLabel(field) }}</label>
              <p class="text-gray-900">{{ field.value || '-' }}</p>
            </div>
          </div>
          <div *ngIf="customFieldValues.length === 0" class="text-center text-gray-500 py-8">
            Nenhum campo personalizado preenchido
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 4: Serviços -->
      <p-tabpanel header="Serviços">
        <div class="mt-4">
          <div *ngIf="selectedServiceOrder.items && selectedServiceOrder.items.length > 0">
            <div class="overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Serviço</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantidade</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Valor Unit.</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr *ngFor="let item of selectedServiceOrder.items">
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.serviceName }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ item.quantity }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">R$ {{ item.price | number: '1.2-2' }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">R$ {{ item.total | number: '1.2-2' }}</td>
                  </tr>
                </tbody>
                <tfoot class="bg-gray-50">
                  <tr>
                    <td colspan="3" class="px-6 py-4 text-right text-sm font-semibold text-gray-700">Total:</td>
                    <td class="px-6 py-4 text-sm font-bold text-green-600">R$ {{ selectedServiceOrder.total | number: '1.2-2' }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div *ngIf="!selectedServiceOrder.items || selectedServiceOrder.items.length === 0" class="text-center text-gray-500 py-8">
            Nenhum serviço adicionado
          </div>
        </div>
      </p-tabpanel>
    </p-tabview>
  </div>
  
  <div *ngIf="loadingModal" class="flex justify-center items-center py-12">
    <i class="pi pi-spin pi-spinner text-4xl text-orange-500"></i>
  </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
<p-toast />

